<script setup lang="ts">
import { useTranslation } from '@hfc/ui-core';

defineProps<{
  companyPays: string,
  youPay: string,
  notes?: Array<string>,
}>();

const { t } = useTranslation();
</script>
<template>
  <div class="flex flex-col justify-end h-full text-white mt-4">
    <div class="flex w-full flex-col px-6 py-4 bg-blue-400 rounded-md">
      <div class="flex justify-center">
        <h6 class="font-semibold text-white">{{ t('metalPlans.estimatedAvgMedicalCosts') }}</h6>
      </div>
      <table>
        <thead>
          <tr>
            <td class="flex min-w-[130px]">{{ t('metalPlans.insuranceCompanyPays') }}</td>
            <td class="font-bold lining-nums text-right" v-html="companyPays"></td>
          </tr>
          <tr>
            <td class="flex min-w-[130px]">{{ t('metalPlans.youPay') }}</td>
            <td class="font-bold lining-nums text-right" v-html="youPay"></td>
          </tr>
        </thead>
      </table>
      <div v-if="notes?.length" class="flex flex-col mt-2 text-xs">
        <span v-for="note in notes" :key="note">{{ note }}</span>
      </div>
    </div>
  </div>
</template>
